<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>sync_alt</mat-icon>
        <h1>{{'入退場状況：閲覧' | translate}}</h1>
      </div>

      <button mat-button (click)="onNoClick()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div mat-dialog-content>

    <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

      <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

        <div>
          <label>{{'イベント' | translate}}</label>
          <div *ngIf="!!event && !!event.names">
            {{ event.names[0].name }}
          </div>
        </div>

        <form class="form" [formGroup]="viewForm">
          <mat-form-field fxFlex="50%">
            <mat-label>{{'来場日' | translate}}</mat-label>
            <mat-select placeholder="{{'来場日' | translate}}" formControlName="date" (valueChange)="changeDate($event)">
              <mat-option value=""></mat-option>
              <mat-option *ngFor="let date of dates" [value]="date">{{ date.substring(0, 4) + '/' + date.substring(4, 6) + '/' + date.substring(6, 8) }}</mat-option>
            </mat-select>
          </mat-form-field>
        </form>

        <div fxLayout="row" fxLayoutGap="20px">
          {{'▼入場口' | translate}}
        </div>
        <table>
          <thead>
            <tr>
              <th width="30px">No.</th>
              <th>{{'名前' | translate}}</th>
              <th width="100px">{{'通過回数' | translate}}</th>
              <th width="200px">{{'最終通過日時' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i = index; let transit of getTransits(gateTypeEntrance)">
              <td>{{ i + 1 }}</td>
              <ng-container *ngFor="let entrance of event.entrances">
                <td *ngIf="entrance.index === transit.entrance_exit_id">{{ entrance.name }}</td>
              </ng-container>
              <td>{{ transit.count }}</td>
              <td>{{ transit.updated.seconds * 1000 | date: 'yyyy/MM/dd HH:mm:ss' }}</td>
            </tr>
          </tbody>
        </table>

        <br>
        <br>
        <div fxLayout="row" fxLayoutGap="20px">
          {{'▼退場口' | translate}}
        </div>
        <table>
          <thead>
            <tr>
              <th width="30px">No.</th>
              <th>{{'名前' | translate}}</th>
              <th width="100px">{{'通過回数' | translate}}</th>
              <th width="200px">{{'最終通過日時' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i = index; let transit of getTransits(gateTypeExit)">
              <td>{{ i + 1 }}</td>
              <ng-container *ngFor="let exit of event.exits">
                <td *ngIf="exit.index === transit.entrance_exit_id">{{ exit.name }}</td>
              </ng-container>
              <td>{{ transit.count }}</td>
              <td>{{ transit.updated.seconds * 1000 | date: 'yyyy/MM/dd HH:mm:ss' }}</td>
            </tr>
          </tbody>
        </table>


      </div>

      <div class="dialog-right" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">

        <div>
          <label>{{'エントリー番号' | translate}}</label>
          <div *ngIf="!!entry && entry.entry_no">
            {{ entry.entry_no }}
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="20px">
          {{'▼展示' | translate}}
        </div>
        <table>
          <thead>
            <tr>
              <th width="30px">No.</th>
              <th>{{'名前' | translate}}</th>
              <th width="100px">{{'来場回数' | translate}}</th>
              <th width="200px">{{'最終来場日時' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i = index; let transit of getTransits(gateTypeExhibit)">
              <td>{{ i + 1 }}</td>
              <ng-container *ngFor="let exhibit of exhibits">
                <td *ngIf="exhibit.id === transit.entrance_exit_id">{{ exhibit.exhibit_names[0].name }}</td>
              </ng-container>
              <td>{{ transit.count }}</td>
              <td>{{transit.updated.seconds * 1000 | date: 'yyyy/MM/dd HH:mm:ss' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
